import { render, staticRenderFns } from "./RelatorioIa.vue?vue&type=template&id=b4608c8e&"
import script from "./RelatorioIa.vue?vue&type=script&lang=js&"
export * from "./RelatorioIa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports